export function assertPreloaded<T>(value: T | null | undefined, name: string): T {
  if (value === null || value === undefined) {
    throw new Error(`StorePreloader: '${name}' read before preload completed`);
  }
  return value;
}
